// function myFunction() {
//     location.replace("https://backoffice.upg.dev.ainosi.com/")
//   }
export default [
    // {
    // 	url: '/services',
    // 	name: "Home",
    // 	slug: "Home",
    // 	icon: "HomeIcon"
    // },
    // {
    // 	url: '/dashboard',
    // 	name: "Dashboard",
    // 	slug: "dashboard",
    // 	icon: "HomeIcon"
    // },
    {
        header: "Account"
    },
    {
        url: '/account/info',
        name: "Account Information",
        slug: "accountInformation",
        icon: "InfoIcon",
        group: "Account"
    },
    {
        header: "Service"
    },
    // {
    //     url: '/services',
    //     name: "Services",
    //     slug: "services",
    //     icon: "BriefcaseIcon",
    //     group: "Service"
    // },
    // {
    //     url: '/services/tourism',
    //     name: "Tourism & Transport",
    //     slug: "services",
    //     featherIcon: true,
    //     iconPack: "feather",
    //     icon: "StarIcon",
    //     group: "Service"
    // },
    {
        url: '/services/payment',//window.location.href = 'http://www.google.com',//'/payment/',
        name: "Payment",
        slug: "services",
        featherIcon: true,
        iconPack: "feather",
        icon: "DollarSignIcon",
        group: "Service"
    },
    {
        header: "Dashboard"
    },
    {
        url: '/dashboard/device-monitoring',
        name: "Dashboard Device Monitoring",
        slug: "dashboardDeviceMonitoring",
        featherIcon: true,
        iconPack: "feather",
        icon: "SmartphoneIcon",
        group: "Dashboard"
    },
    {
        url: '/dashboard/transaction-summary',
        name: "Dashboard Transaction Summary    ",
        slug: "dashboardTransactionSummary",
        featherIcon: true,
        iconPack: "feather",
        icon: "SmartphoneIcon",
        group: "Dashboard"
    },
    // {
    //     url: '/services/retail',
    //     name: "Retail",
    //     slug: "services",
    //     featherIcon: true,
    //     iconPack: "feather",
    //     icon: "ShoppingBagIcon",
    //     group: "Service"
    // },
    // {
    //     url: '/services/loyalty',
    //     name: "Loyalty",
    //     slug: "services",
    //     featherIcon: true,
    //     iconPack: "feather",
    //     icon: "AwardIcon",
    //     group: "Service"
    // },
    // {
    //     url: '/services/bi',
    //     name: "Business Inteligence",
    //     slug: "services",
    //     featherIcon: true,
    //     iconPack: "feather",
    //     icon: "BarChart2Icon",
    //     group: "Service"
    // },
    {
        header: "Merchant",
        slug: "merchantManagement",
    },
    {
        url: '/merchant',
        name: "Management",
        slug: "merchantManagement",
        featherIcon: true,
        iconPack: "feather",
        icon: "ShoppingBagIcon",
        group: "Merchant"
    },
    {
        url: '/merchant/verification',
        name: "Verification",
        slug: "verificationRequest",
        featherIcon: true,
        iconPack: "feather",
        icon: "CheckSquareIcon",
        group: "Merchant"
    },
    // {
    //     url: '/shiftdate',
    //     name: "Shiftdate Mapping",
    //     slug: "ShiftdateMapping",
    //     featherIcon: true,
    //     iconPack: "feather",
    //     icon: "Link2Icon",
    //     group: "Merchant"
    // },
    {
        url: '/location-mapping',
        name: "Location Mapping",
        slug: "LocationMapping",
        featherIcon: true,
        iconPack: "feather",
        icon: "Link2Icon",
        group: "Merchant"
    },
    {
        url: '/svd-location-mapping',
        name: "SVD Location Mapping",
        slug: "SVDLocationMapping",
        featherIcon: true,
        iconPack: "feather",
        icon: "Link2Icon",
        group: "Merchant"
    },
    {
        url: '/tid-and-mid-management',
        name: "MID & TID Management",
        slug: "TID&MIDManagement",
        featherIcon: true,
        iconPack: "feather",
        icon: "TerminalIcon",
        group: "Merchant"
    },
    {
        header: "Device Management"
    },
    {
        url: '/device/type',
        name: "Device Type",
        slug: "deviceType",
        featherIcon: true,
        iconPack: "feather",
        icon: "SmartphoneIcon",
        group: "Device Management"
    },
    // {
    //     url: '/device/list',
    //     name: "Device Registration",
    //     slug: "deviceType",
    //     featherIcon: true,
    //     iconPack: "feather",
    //     icon: "SmartphoneIcon",
    //     group: "Device Management"
    // },
    {
        url: '/device/request',
        name: "Request for Devices",
        slug: "requestForDevices",
        featherIcon: true,
        iconPack: "feather",
        icon: "ShoppingBagIcon",
        group: "Device Management"
    },
    // {
    //     url: '/device/assignment',
    //     name: "Devices Assignment",
    //     slug: "devicesAssignment",
    //     featherIcon: true,
    //     iconPack: "feather",
    //     icon: "ShoppingBagIcon",
    //     group: "Device Management"
    // },
    {
        url: '/device/setup',
        name: "Devices Setup",
        slug: "deviceSetup",
        featherIcon: true,
        iconPack: "feather",
        icon: "ShoppingBagIcon",
        group: "Device Management",
    },
    {
        url: '/device/report',
        name: "Device Report",
        slug: "DeviceMonitoring",
        featherIcon: true,
        iconPack: "feather",
        icon: "BookIcon",
        group: "Device Management"
    },
    {
        url: '/device/monitoring',
        name: "Device Monitoring",
        slug: "deviceReport",
        featherIcon: true,
        iconPack: "feather",
        icon: "SmartphoneIcon",
        group: "Device Management"
    },
    // {
    //     url: '/device/activity/log',
    //     name: "Device Activity Log",
    //     slug: "DeviceActivityLog",
    //     featherIcon: true,
    //     iconPack: "feather",
    //     icon: "ActivityIcon",
    //     group: "Device Management"
    // },
    {
        url: '/device/transaction/summaries',
        name: "Transaction Summaries",
        slug: "DeviceTransactionSummaries",
        featherIcon: true,
        iconPack: "feather",
        icon: "FileTextIcon",
        group: "Device Management"
    },
    // {
    //     url: '/device/event',
    //     name: "Device Event",
    //     slug: "DeviceEvent",
    //     featherIcon: true,
    //     iconPack: "feather",
    //     icon: "SmartphoneIcon",
    //     group: "Device Management",
    // },
    // {
    //     url: '/device/update',
    //     name: "Device Update",
    //     slug: "deviceUpdate",
    //     featherIcon: true,
    //     iconPack: "feather",
    //     icon: "SmartphoneIcon",
    //     group: "Device Management"
    // },
    {
        url: '/device/request-devices',
        name: "Device Request",
        slug: "deviceRequest",
        featherIcon: true,
        iconPack: "feather",
        icon: "SmartphoneIcon",
        group: "Device Management"
    },
    {
        url: '/device/mapping',
        name: "Device Mapping",
        slug: "devicemapping",
        featherIcon: true,
        iconPack: "feather",
        icon: "SmartphoneIcon",
        group: "Device Management"
    },
    {
        header: "Settings"
    },
    // {
    // 	url: '/account/settings',
    // 	name: "Account Settings",
    // 	slug: "accountSettings",
    // 	icon: "SettingsIcon"
    // },
    {
        url: '/users',
        name: "User Management",
        slug: "userList",
        icon: "UsersIcon",
        group: "Settings"
    },
    {
        header: "Audit Trail"
    },
    {
        url: '/audit-trail/list',
        name: "Audit Trail",
        slug: "audittrail",
        featherIcon: true,
        iconPack: "feather",
        icon: "UsersIcon",
        group: "Audit Trail"
    },
    // {
    // 	url: '/device/assignment',
    // 	name: "Device Assignment",
    // 	slug: "deviceAssignment",
    // 	featherIcon: true,
    // 	iconPack: "feather",
    // 	icon: "ShoppingBagIcon"
    // },
    // {
    // 	header: "Help & Support"
    // },
    // {
    // 	url: 'https://pixinvent.com/demo/vuesax-vuejs-admin-dashboard-template/documentation/',
    // 	name: "Documentation",
    // 	icon: "BookOpenIcon",
    // 	slug: "external",
    // 	i18n: "Documentation",
    // 	target: "_blank"
    // },
    // {
    // 	url: 'https://pixinvent.ticksy.com/',
    // 	name: "Raise Support",
    // 	icon: "LifeBuoyIcon",
    // 	slug: "external",
    // 	i18n: "RaiseSupport",
    // 	target: "_blank"
    // },
]